import { SET_GOOGLE_CONTACT } from "constants/app";

export default (state = [], action) => {
  switch (action.type) {
    case SET_GOOGLE_CONTACT:
      return action.googleContacts;
    default:
      return state;
  }
};
